<template>
  <el-card shadow="nerver" class="box-card">
    <div class="member-info">
      <el-row v-if="!isAutonomousEnrolment">
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="6" class="member-info-label">
          <span>手机号码：</span>
        </el-col>
        <el-col :span="8">
          <span>{{financialModel.phone}}</span>
        </el-col>
      </el-row>
      <el-row v-if="displayEnrollmentCount && (dataIn.courseType == 1 || dataIn.courseType == 3)">
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="6" class="member-info-label">
          <span>可用占位数：</span>
        </el-col>
        <el-col :span="8" v-if="dataIn.courseType == 3">
          <span>{{availableEnrollmentCount}}</span>
          <span v-if="financialModel.enrollmentCount > 0">({{availableEnrollmentAmount|toCurrency}})</span>
        </el-col>
        <el-col :span="8" v-if="dataIn.courseType == 1">
          <span>{{studentAvailableAdvanceEnrollmentCount}}</span>
        </el-col>
      </el-row>
      <el-row v-if="!isAutonomousEnrolment">
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="6" class="member-info-label">
          <span>积分：</span>
        </el-col>
        <el-col :span="8">
          <span>{{availableBonusPoint}}</span><span v-if="financialModel.bonusPoint > 0">({{availableBonusPointAmount|toCurrency}})</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="6" class="member-info-label">
          <span>余额：</span>
        </el-col>
        <el-col :span="8">
          <span>${{availableBalance | toFixedString }}</span>
          <span v-if="financialModel.balance > 0">
            <br />
            <span v-if="dataIn.memberModel.GiftBalance > 0">赠送余额 {{dataIn.memberModel.GiftBalance | toFixedString}}<br /></span>
            <span v-if="dataIn.memberModel.Balance > 0">旧余额 {{dataIn.memberModel.Balance | toFixedString}}<br /></span>
            <span v-if="dataIn.memberModel.NewBalance > 0">新余额 {{dataIn.memberModel.NewBalance | toFixedString}}</span>

          </span>
        </el-col>
      </el-row>
      <el-row v-if="!isAutonomousEnrolment">
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="6" class="member-info-label">
          <span>欠款：</span>
        </el-col>
        <el-col :span="8">
          <span>{{financialModel.balanceDue | toCurrency}}</span>
        </el-col>
      </el-row>
      <el-row v-if="dataIn.courseType == 2">
        <el-col :span="2">
          &nbsp;
        </el-col>
        <el-col :span="6" class="member-info-label">
          <span>保分：</span>
        </el-col>
        <el-col :span="14">
          <span>听{{!englishEnsureScoreData.Listening ? "-" : englishEnsureScoreData.Listening}}/</span>
          <span>说{{!englishEnsureScoreData.Speaking ? "-" : englishEnsureScoreData.Speaking}}/</span>
          <span>读{{!englishEnsureScoreData.Reading ? "-" : englishEnsureScoreData.Reading}}/</span>
          <span>写{{!englishEnsureScoreData.Writing ? "-" : englishEnsureScoreData.Writing}}/</span>
          <span>总分{{!englishEnsureScoreData.Overall ? "-" : englishEnsureScoreData.Overall}}</span>
          <el-button class="cs-englishEnsureScore-editButton" type="text" v-if="!isReadOnly" @click="onDisplayEditorClick">编辑</el-button>
        </el-col>
      </el-row>
    </div>
    <el-form v-if="!isAdEnrollment && !isSupplement" ref="frm2" :model="model" :rules="rules" label-width="120px" label-position="right">
      <div v-if="bonusPointEditable || cashDecreasedEditable">
        <el-form-item label="使用积分：" v-if="bonusPointEditable" prop="bonusPoint">
          <div v-if="isReadOnly">{{model.bonusPoint}}</div>
          <div v-else>
            <el-input placeholder="请输入积分" :disabled="isBonusPointDisabled" v-model="model.bonusPoint" @change="onBonusPointChange" />
            <span class="bonusPoint-desc" v-if="isBonusPointDisabled">非会员无法使用积分</span>
          </div>
        </el-form-item>
        <el-form-item label="使用现金减：" v-if="cashDecreasedEditable" prop="cashDecreased">
          <div v-if="isReadOnly">{{model.cashDecreased}}</div>
          <el-input v-else placeholder="请输入现金减" @change="onCashDecreasedChange" v-model="model.cashDecreased" class="input-width">
          </el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="comment">
          <div v-if="isReadOnly">{{model.comment}}</div>
          <el-input v-else type="textarea" rows="3" placeholder="" v-model="model.comment" class="input-width">
          </el-input>
        </el-form-item>
        <el-form-item v-if="!isReadOnly" class="cs-balanceEditor-btn">
          <el-button :disabled="submitBtnDisable" :type="submitBtnClass" size="mini"
            @click="saveCashDecreased()">保存现金减{{!isBonusPointDisabled ? "/积分" : ""}}</el-button>
        </el-form-item>
      </div>
      <el-form-item label="代理折扣码：" prop="couponCode">
        <div v-if="isReadOnly">
          {{couponModel.couponCode}}
          <span v-if="couponModel.couponDiscountValue"> 折扣：{{getCouponDiscountDesc(couponModel.couponDiscountValue)}}</span>
        </div>
        <div v-else>
          <el-input placeholder="请输入代理折扣码" v-model="couponModel.couponCode" size="small"></el-input>
          <el-button type="primary" size="mini" @click="onCouponCodeClick">验证</el-button>
          <el-button type="primary" size="mini" @click="onCouponRevertClick" v-if="couponModel.couponDiscountValue">撤销</el-button>
          <span v-if="couponModel.couponDiscountValue"> 折扣：{{getCouponDiscountDesc(couponModel.couponDiscountValue)}}</span>
        </div>
      </el-form-item>
    </el-form>

    <el-form v-if="hasEnrollmentCount || hasBalance || isSupplement" ref="frm" :model="model" :rules="rules" label-width="120px" label-position="right">
      <el-form-item v-if="hasEnrollmentCount" label="使用占位：" prop="enrollmentCount">
        <div v-if="dataIn.courseType == 3 && isReadOnly">{{model.enrollmentCount}}</div>
        <el-input v-if="dataIn.courseType == 3 && !isReadOnly" placeholder="请输入占位数" @change="onEnrollmentCountChange" v-model="model.enrollmentCount"
          class="input-width">
        </el-input>

        <el-select :disabled="isReadOnly" v-if="dataIn.courseType == 1" size="small" placeholder="选择占位" v-model="studentAdvanceEnrollmentAdditionalList"
          multiple @change="onstudentAdvanceEnrollmentAdditionalListChange">
          <el-option v-for="ae in availableStudentAdvanceEnrollmentList" :label="`定金: ${ae.Amount} $ | 折扣: ${ae.Discount} % ${ae.Comment}`" :key="ae.Key"
            :value="ae.Id" />
        </el-select>

      </el-form-item>
      <el-form-item v-if="isSupplement" label="">
        <el-checkbox v-model="isReduce" @change="onReduceChange">是否扣除已使用</el-checkbox>
      </el-form-item>
      <el-form-item label="使用余额：" prop="balance" v-if="hasBalance">
        <div v-if="isReadOnly">{{model.balance}}</div>
        <el-input v-else placeholder="请输入余额" @change="onBalanceChange" v-model="model.balance" class="input-width">
        </el-input>
      </el-form-item>
      <el-form-item v-if="!isReadOnly" class="cs-balanceEditor-btn">
        <el-button :disabled="submitBtnDisable" :type="submitBtnClass" size="small" @click="save()">确认</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="editorVisible" top="3vh">
      <englishEnsureScoreEditor :dataIn="englishEnsureScoreData" @closeDialog="onEditorClose" @saveSuccess="onEditorSave"></englishEnsureScoreEditor>
    </el-dialog>
  </el-card>
</template>

<style lang="scss" scoped>
.box-card {
  background-color: #f5f7fa;

  .el-input-number {
    width: 100%;
  }
  .member-info {
    padding-bottom: 10px;
    .member-info-label {
      text-align: right;
      margin-right: 1rem;
    }
  }

  .el-row {
    padding-left: 18px;
    margin-bottom: 5px;
  }

  .el-form-item {
    margin-bottom: 5px;
  }
  .cs-balanceEditor-btn {
    text-align: right;
  }
}
.cs-englishEnsureScore-editButton {
  padding-top: 0;
  padding-bottom: 0;
}

.bonusPoint-desc {
  display: block;
  margin-top: -10px;
}
</style>

<script>
import {
  getEnglishEnsureScore,
  saveEnglishEnsureScore,
  validateCoupon,
} from "../../service/enrollmentFee.service";
import englishEnsureScoreEditor from "./courseEnrollmentFee/englishEnsureScoreEditor";
import { convertToFloat, getDiscountDesc } from "../../config/mUtils.js";

const mixin_generalMethods = {
  methods: {
    __convertBonusPointToAmount(bonusPoint) {
      let amount = 0;

      if (this.bonusPointToMoney_BonusPoint > 0) {
        amount = (
          (bonusPoint * this.bonusPointToMoney_Money) /
          this.bonusPointToMoney_BonusPoint
        ).toFixedEx(0);
      }

      return amount;
    },
    __convertADEnrollmentCountToAmount(adeCount) {
      let amount = adeCount * this.adEnrollmentPrice;
      if (amount < 0) amount = 0;

      return amount;
    },
  },
};

export default {
  mixins: [mixin_generalMethods],
  props: {
    isReadOnly: Boolean,
    isAutonomousEnrolment: Boolean,
    isSupplement: Boolean, //是否补款
    isAdEnrollment: Boolean, //是否是占位模式
    displayEnrollmentCount: Boolean,
    bonusPointEditable: Boolean,
    cashDecreasedEditable: Boolean,
    isContinuePayment: Boolean,
    bonusPointDisabled: {
      type: Boolean,
      default: false,
    },
    dataIn: {
      workflowId: Number,
      memberModel: Object,
      enrollmentCountUsed: Number,
      accountAmount: Number,
      accountAmountWithTax: Number,
      balanceInStore: Number,
      courseType: Number,
      priceSettings: Object,
      studentAdvanceEnrollmentList: Array,
      advanceEnrollmentTotalPrice: Number,
      //已使用的优惠，扣除使用
      modelUsedData: {
        enrollmentCount: Number,
        balance: Number,
        bonusPoint: Number,
        cashDecreased: Number,
        studentAdvanceEnrollmentAdditional: String,
        comment: String,
      },
      modelData: {
        enrollmentCount: Number,
        balance: Number,
        bonusPoint: Number,
        cashDecreased: Number,
        studentAdvanceEnrollmentAdditional: String,
        comment: String,
        __bonusPointChanged: Boolean,
        __cashDecreasedChanged: Boolean,
      },
      couponData: {
        couponCode: String,
        couponDiscountValue: Number,
      },
    },
  },
  data() {
    let self = this;

    let validateEnrollmentCount = (rule, value, callback) => {
      if (!value || this.dataIn.courseType != 3) {
        callback();
      }

      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      let nValue = `${value}`.toNumber().toFixedEx(0);

      if (!!value && !isValid) message = "请输入正确的占位数值";

      let enrollmentCountUsed = `${self.dataIn.enrollmentCountUsed}`
        .toNumber()
        .toFixedEx(0);
      if (!message) {
        if (this.isReduce) {
          let enrollmentCountUsed2 =
            `${self.dataIn.modelUsedData.enrollmentCount}`
              .toNumber()
              .toFixedEx(0);
          if (nValue > enrollmentCountUsed2)
            message = "扣除的占位不能大于已使用的占位";
        } else {
          let fmEnrollmentCount = `${self.financialModel.enrollmentCount}`
            .toNumber()
            .toFixedEx(0);
          let count = fmEnrollmentCount - enrollmentCountUsed;
          if (count < 0) count = 0;
          if (nValue > count) message = "使用占位不能大于可用占位";
        }
      }

      let enrollmentAmount = this.__convertADEnrollmentCountToAmount(
        enrollmentCountUsed + nValue
      );
      let accountAmountWithTax = `${this.dataIn.accountAmountWithTax}`
        .toNumber()
        .toFixedEx(2);
      let balance = `${self.model.balance}`.toNumber().toFixedEx(2);
      let amount = accountAmountWithTax - balance;
      if (amount < 0) amount = 0;
      if (!this.isAutonomousEnrolment && !message && enrollmentAmount > amount)
        message = "使用占位金额不能大于应付价格";

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateBalance = (rule, value, callback) => {
      if (!value) {
        callback();
      }

      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      let nValue = `${value}`.toNumber().toFixedEx(2);

      if (!!value && !isValid) message = "请输入正确的余额数值";

      if (self.isReduce) {
        let balanceUsed = `${self.dataIn.modelUsedData.balance}`
          .toNumber()
          .toFixedEx(2);
        if (!message && nValue > balanceUsed)
          message = "扣除的余额不能大于已使用的余额";
      } else {
        let fmBalance = self.financialModel.balance;
        if (!message && nValue > fmBalance) {
          message = "余额数值不能大于可用余额";
        }

        let accountAmountWithTax = `${self.dataIn.accountAmountWithTax}`
          .toNumber()
          .toFixedEx(2);
        let amount = accountAmountWithTax - self.enrollmentAmount;
        //解决有已存余额(付款或占位超出应付金额)时，应付金额错误的问题
        if (
          self.isSupplement &&
          !!self.dataIn.balanceInStore &&
          self.dataIn.balanceInStore > 0
        ) {
          amount += self.dataIn.balanceInStore;
        }
        amount = amount.toFixedEx(2);
        if (amount < 0) amount = 0;
        if (
          !self.isAutonomousEnrolment &&
          !message &&
          !!nValue &&
          nValue > amount
        ) {
          message = "使用余额不能大于应付价格";
        }

        //占位不能使用赠送余额
        if (this.isAdEnrollment && !message) {
          let balanceWithoutGiftBalance =
            self.financialModel.balance - self.dataIn.memberModel.GiftBalance;
          if (nValue > balanceWithoutGiftBalance) {
            message =
              "占位不能使用赠送余额，使用余额数值不能大于除赠送余额外的可用余额";
          }
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateBonusPoint = (rule, value, callback) => {
      if (!value) {
        callback();
      }

      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      let nValue = `${value}`.toNumber().toFixedEx(0);

      if (!!value && !isValid) message = "请输入正确的积分数值";

      let fmBonusPoint = `${self.financialModel.bonusPoint}`
        .toNumber()
        .toFixedEx(0);
      if (!message && nValue > fmBonusPoint)
        message = "积分数值不能大于可用积分";

      let bpAmount = self.__convertBonusPointToAmount(nValue);
      if (self.isReduce) {
        let bpUsed = `${self.dataIn.modelUsedData.bonusPoint}`
          .toNumber()
          .toFixedEx(0);
        let bpAmountUsed = self.__convertBonusPointToAmount(bpUsed);
        if (!message && bpAmount > bpAmountUsed)
          message = `扣除的积分抵扣金额(${bpAmount})不能大于已使用的积分抵扣金额(${bpAmountUsed})`;
      } else {
        let accountAmount = `${self.dataIn.accountAmount}`
          .toNumber()
          .toFixedEx(2);
        let bpUsed = `${self.dataIn.modelData.bonusPoint}`
          .toNumber()
          .toFixedEx(0);
        let bpAmountUsed = self.__convertBonusPointToAmount(bpUsed);
        let cashDecreasedUsed = `${self.dataIn.modelData.cashDecreased}`
          .toNumber()
          .toFixedEx(0);
        let cashDecreasedCurrent = `${self.model.cashDecreased}`
          .toNumber()
          .toFixedEx(0);
        let amount =
          accountAmount +
          bpAmountUsed +
          cashDecreasedUsed -
          cashDecreasedCurrent;
        if (!message && !!bpAmount && bpAmount > amount) {
          message = `积分抵扣金额(${bpAmount})不能大于应付价格`;
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateCashDecreased = (rule, value, callback) => {
      if (!value) {
        callback();
      }

      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      let nValue = `${value}`.toNumber().toFixedEx(0);

      if (!!value && !isValid) message = "请输入正确的现金减数值";

      if (self.isReduce) {
        let cashDecreasedUsed = `${self.dataIn.modelUsedData.cashDecreased}`
          .toNumber()
          .toFixedEx(0);
        if (!message && nValue > cashDecreasedUsed)
          message = "扣除的现金减不能大于已使用的现金减";
      } else {
        let accountAmount = `${self.dataIn.accountAmount}`
          .toNumber()
          .toFixedEx(0);
        let bpUsed = `${self.dataIn.modelData.bonusPoint}`
          .toNumber()
          .toFixedEx(0);
        let bpAmountUsed = self.__convertBonusPointToAmount(bpUsed);
        let bpCurrent = `${self.model.bonusPoint}`.toNumber().toFixedEx(0);
        let bpAmountCurrent = self.__convertBonusPointToAmount(bpCurrent);
        let cashDecreasedUsed = `${self.dataIn.modelData.cashDecreased}`
          .toNumber()
          .toFixedEx(0);
        let amount =
          accountAmount + bpAmountUsed + cashDecreasedUsed - bpAmountCurrent;
        if (amount < 0) amount = 0;
        if (!message && !!nValue && nValue > amount)
          message = "使用现金减不能大于应付价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isChanged: false,
      editorVisible: false,
      isReduce: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      bonusPointToMoney_Money: 0,
      bonusPointToMoney_BonusPoint: 0,
      adEnrollmentPrice: 0,
      isUseBonusPoint: false,
      studentAdvanceEnrollmentAdditionalList: "",
      studentAdvanceEnrollmentAdditionalAmount: 0,
      advanceEnrollmentTotalPriceForCourse: 0,
      studentAvailableAdvanceEnrollmentCount: 0,

      financialModel: {
        enrollmentCount: 0,
        balance: 0,
        bonusPoint: 0,
      },
      model: {
        enrollmentCount: 0,
        balance: 0,
        bonusPoint: 0,
        cashDecreased: 0,
        studentAdvanceEnrollmentAdditional: "",
        comment: "",
      },
      couponModel: {
        couponCode: "",
        couponDiscountValue: null,
      },
      rules: {
        enrollmentCount: [
          {
            validator: validateEnrollmentCount,
            trigger: "blur",
          },
        ],
        balance: [
          {
            validator: validateBalance,
            trigger: "blur",
          },
        ],
        bonusPoint: [
          {
            validator: validateBonusPoint,
            trigger: "blur",
          },
        ],
        cashDecreased: [
          {
            validator: validateCashDecreased,
            trigger: "blur",
          },
        ],
      },
      englishEnsureScoreData: {
        Id: 0,
        Overall: "",
        Listening: "",
        Speaking: "",
        Reading: "",
        Writing: "",
        WorkflowId: 0,
      },
    };
  },
  components: {
    englishEnsureScoreEditor,
  },
  computed: {
    availableStudentAdvanceEnrollmentList() {
      return this.dataIn.studentAdvanceEnrollmentList.filter(
        (item) =>
          !item.Used ||
          this.studentAdvanceEnrollmentAdditionalList.indexOf(item.Id) >= 0
      );
    },
    availableBalance() {
      let fmBalance = `${this.financialModel.balance}`.toNumber().toFixedEx(2);
      if (this.isReadOnly) {
        return fmBalance;
      }

      let balance = `${this.model.balance}`.toNumber().toFixedEx(2);
      let value = this.isReduce ? fmBalance + balance : fmBalance - balance;
      if (value < 0) value = 0;

      return value;
    },
    availableBonusPoint() {
      let fmBonusPoint = `${this.financialModel.bonusPoint}`
        .toNumber()
        .toFixedEx(0);
      if (this.isReadOnly || this.isContinuePayment) {
        return fmBonusPoint;
      }

      let bonusPoint = `${this.model.bonusPoint}`.toNumber().toFixedEx(0);
      let value = this.isReduce
        ? fmBonusPoint + bonusPoint
        : fmBonusPoint - bonusPoint;
      if (value < 0) value = 0;

      return value;
    },
    availableBonusPointAmount() {
      return this.__convertBonusPointToAmount(this.availableBonusPoint);
    },
    availableEnrollmentCount() {
      let fmEnrollmentCount = `${this.financialModel.enrollmentCount}`
        .toNumber()
        .toFixedEx(0);
      if (this.isReadOnly) {
        return fmEnrollmentCount;
      }

      let enrollmentCount = `${this.model.enrollmentCount}`
        .toNumber()
        .toFixedEx(0);
      let enrollmentCountUsed = `${this.dataIn.enrollmentCountUsed}`
        .toNumber()
        .toFixedEx(0);
      let value = fmEnrollmentCount - enrollmentCountUsed;
      value = this.isReduce ? value + enrollmentCount : value - enrollmentCount;
      if (value < 0) value = 0;

      return value;
    },
    availableEnrollmentAmount: function () {
      return this.__convertADEnrollmentCountToAmount(
        this.availableEnrollmentCount
      );
    },
    enrollmentAmount: function () {
      if (this.courseType == 3) {
        let enrollmentCount = `${this.model.enrollmentCount}`
          .toNumber()
          .toFixedEx(0);
        if (!!this.dataIn) {
          let enrollmentCountUsed = `${this.dataIn.enrollmentCountUsed}`
            .toNumber()
            .toFixedEx(0);
          enrollmentCount += enrollmentCountUsed;
        }
        return this.__convertADEnrollmentCountToAmount(enrollmentCount);
      } else {
        return (
          this.advanceEnrollmentTotalPriceForCourse +
          this.studentAdvanceEnrollmentAdditionalAmount
        );
      }
    },
    hasEnrollmentCount() {
      return (
        !this.isAdEnrollment &&
        this.dataIn.courseType != 2 &&
        this.studentAvailableAdvanceEnrollmentCount > 0
      );
    },
    hasBalance() {
      return (
        this.financialModel.balance > 0 ||
        this.model.balance > 0 ||
        !!this.dataIn.modelUsedData.balance
      );
    },
    isBonusPointDisabled() {
      let fmBonusPoint = `${this.financialModel.bonusPoint}`
        .toNumber()
        .toFixedEx(0);
      let bonusPoint = `${this.model.bonusPoint}`.toNumber().toFixedEx(0);
      let bonusPointUsed = `${this.dataIn.modelUsedData.bonusPoint}`
        .toNumber()
        .toFixedEx(0);

      return (
        this.bonusPointDisabled ||
        (fmBonusPoint <= 0 && bonusPoint <= 0 && !bonusPointUsed)
      );
    },
  },
  created() {
    this.init();
  },
  updated() {},
  methods: {
    init() {
      this.loadFinancialModel();
      if (!!this.dataIn && !!this.dataIn.modelData) {
        this.model = Object.clone(this.dataIn.modelData);
        if (this.model.bonusPoint > 0) {
          this.isUseBonusPoint = true;
        } else {
          this.isUseBonusPoint = false;
        }
      }

      if (this.dataIn && this.dataIn.couponData) {
        this.couponModel = this.dataIn.couponData;
      }

      if (!!this.dataIn && !!this.dataIn.priceSettings) {
        this.bonusPointToMoney_Money =
          this.dataIn.priceSettings.bonusPointToMoney_Money;
        this.bonusPointToMoney_BonusPoint =
          this.dataIn.priceSettings.bonusPointToMoney_BonusPoint;
        this.adEnrollmentPrice = this.dataIn.priceSettings.adEnrollmentPrice;
        if (this.dataIn.courseType == 3) {
          this.adEnrollmentPrice =
            this.dataIn.priceSettings.trainingAdEnrollmentPrice;
        }
      }
      this.englishEnsureScoreData.WorkflowId = this.dataIn.workflowId;

      if (!!this.dataIn.modelData.studentAdvanceEnrollmentAdditional) {
        let list =
          this.dataIn.modelData.studentAdvanceEnrollmentAdditional.split(",");
        this.studentAdvanceEnrollmentAdditionalList = list.map((i) =>
          parseInt(i)
        );
      } else {
        this.studentAdvanceEnrollmentAdditionalList = [];
      }
      this.getStudentAdvanceEnrollmentAdditionalAmount();

      let aeTotalPrice = `${this.dataIn.advanceEnrollmentTotalPrice}`
        .toNumber()
        .toFixedEx(2);
      this.advanceEnrollmentTotalPriceForCourse =
        aeTotalPrice - this.studentAdvanceEnrollmentAdditionalAmount;
      if (this.advanceEnrollmentTotalPriceForCourse < 0) {
        this.advanceEnrollmentTotalPriceForCourse = 0;
      }
      this.loadEnglishEnsureScore();
      if (!!this.dataIn.studentAdvanceEnrollmentList) {
        this.studentAvailableAdvanceEnrollmentCount =
          this.dataIn.studentAdvanceEnrollmentList.filter(
            (i) => !i.Used
          ).length;
      }
    },
    loadEnglishEnsureScore() {
      if (!!this.dataIn && !!this.dataIn.workflowId) {
        getEnglishEnsureScore(this.dataIn.workflowId).then((result) => {
          if (result.success) {
            this.englishEnsureScoreData = result.data;
          }
        });
      } else {
        this.englishEnsureScoreData.Id = 0;
        this.englishEnsureScoreData.Overall = "";
        this.englishEnsureScoreData.Listening = "";
        this.englishEnsureScoreData.Speaking = "";
        this.englishEnsureScoreData.Reading = "";
        this.englishEnsureScoreData.Writing = "";
        this.englishEnsureScoreData.WorkflowId = 0;
      }
    },
    initFinancialModel() {
      let newModel = {
        studentId: 0,
        phone: "",
        bonusPoint: 0,
        balance: 0,
        balanceDue: 0,
        enrollmentCount: 0,
      };

      return newModel;
    },
    checkAllInputs() {
      let isValid = true;

      let $ref = this.$refs["frm"];
      if (!!$ref) {
        $ref.validate((valid) => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }
      return isValid;
    },
    checkAllInputs2() {
      let isValid = true;
      let $ref = this.$refs["frm2"];
      if (!!$ref) {
        $ref.validate((valid) => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }
      return isValid;
    },
    loadFinancialModel() {
      if (!this.dataIn || !this.dataIn.memberModel) {
        this.financialModel = this.initFinancialModel();
        return;
      }

      this.financialModel.studentId = this.dataIn.memberModel.StudentId;
      this.financialModel.phone = this.dataIn.memberModel.Phone;
      this.financialModel.bonusPoint = this.dataIn.memberModel.BonusPoint;
      this.financialModel.balance =
        this.dataIn.memberModel.Balance +
        this.dataIn.memberModel.NewBalance +
        this.dataIn.memberModel.GiftBalance;
      this.financialModel.balanceDue = this.dataIn.memberModel.BalanceDue;
      this.financialModel.enrollmentCount =
        this.dataIn.memberModel.AdvanceEnrollmentCount -
        this.dataIn.memberModel.AdvanceEnrollmentCountUsed;
      //this.financialModel.enrollmentCount = this.dataIn.studentAdvanceEnrollmentList.count;

      if (this.dataIn.courseType == 3) {
        this.financialModel.enrollmentCount =
          this.dataIn.memberModel.TrainingAdvanceEnrollmentCount -
          this.dataIn.memberModel.TrainingAdvanceEnrollmentCountUsed;
      }
    },
    checkBalanceInputs() {
      let isValid = true;

      let $ref = this.$refs["frm"];
      if (!!$ref) {
        $ref.validateField("balance", (errMsg) => {
          if (!!errMsg) {
            isValid = false;
            return;
          }
        });
      }

      return isValid;
    },
    checkBonusPointInputs() {
      let isValid = true;

      let $ref = this.$refs["frm2"];
      if (!!$ref) {
        $ref.validateField("bonusPoint", (errMsg) => {
          if (!!errMsg) {
            isValid = false;
            return;
          }
        });
      }

      return isValid;
    },
    checkCashDecreasedInputs() {
      let isValid = true;

      let $ref = this.$refs["frm2"];
      if (!!$ref) {
        $ref.validateField("cashDecreased", (errMsg) => {
          if (!!errMsg) {
            isValid = false;
            return;
          }
        });
      }

      return isValid;
    },
    onEnrollmentCountChange() {
      this.isChanged = true;
      // this.resetBonusPoint();
    },
    onBalanceChange() {
      this.isChanged = true;
      // this.resetBonusPoint();
    },
    onReduceChange() {
      this.isChanged = true;
      // this.resetBonusPoint();
    },
    onBonusPointChange() {
      this.$set(this.dataIn.modelData, "__bonusPointChanged", true);
      this.checkCashDecreasedInputs();
      // this.resetBonusPoint();
    },
    onCashDecreasedChange() {
      this.$set(this.dataIn.modelData, "__cashDecreasedChanged", true);
      this.checkBonusPointInputs();
      // this.resetBonusPoint();
    },
    onstudentAdvanceEnrollmentAdditionalListChange() {
      this.model.studentAdvanceEnrollmentAdditional = "";
      //this.dataIn.modelData.studentAdvanceEnrollmentAdditional = this.studentAdvanceEnrollmentAdditionalList.toString();
      //let total = 0;
      this.getStudentAdvanceEnrollmentAdditionalAmount();
      this.model.studentAdvanceEnrollmentAdditional =
        this.studentAdvanceEnrollmentAdditionalList.toString();
      this.isChanged = true;
      //this.model.studentAdvanceEnrollmentAdditionalList.forEach(element => {
      //    this.dataIn.modelData.studentAdvanceEnrollmentAdditional += element+",";
      //  });
      this.checkBalanceInputs();
    },
    getStudentAdvanceEnrollmentAdditionalAmount() {
      let amount = 0;
      this.studentAdvanceEnrollmentAdditionalList.forEach((element) => {
        this.dataIn.studentAdvanceEnrollmentList.forEach((sae) => {
          if (element == sae.Id) {
            amount += sae.Amount;
          }
        });
      });
      this.studentAdvanceEnrollmentAdditionalAmount = amount;
    },
    // resetBonusPoint() {
    //   this.isChanged2 = true;
    //   if (this.isReduce) {
    //     if (this.isUseBonusPoint) {
    //       this.model.bonusPoint = this.dataIn.modelUsedData.bonusPoint;
    //     } else {
    //       this.model.bonusPoint = 0;
    //     }
    //   } else {
    //     if (this.isUseBonusPoint) {
    //       this.model.bonusPoint = this.getUsingBonusPoint();
    //       //this.model.bonusPoint = this.financialModel.bonusPoint;
    //     } else {
    //       this.model.bonusPoint = 0;
    //     }
    //   }
    // },
    // getUsingBonusPoint() {
    //   let value = 0;

    //   if (!!this.dataIn && !!this.dataIn.accountAmount) {
    //     let amount =
    //       this.dataIn.accountAmount -
    //       this.enrollmentAmount -
    //       parseInt(this.model.balance) -
    //       parseInt(this.model.cashDecreased);

    //     if (amount > 0) {
    //       if (this.bonusPointToMoney_Money > 0) {
    //         value =
    //           (amount * this.bonusPointToMoney_BonusPoint) /
    //           this.bonusPointToMoney_Money;

    //         if (value > this.financialModel.bonusPoint) {
    //           value = this.financialModel.bonusPoint;
    //         }
    //       }
    //     }
    //   }

    //   return value;
    // },
    onEnrollmentCountClick() {
      this.$refs["frm"].validateField("enrollmentCount", (error) => {
        if (!error) {
          this.$emit("valueChange", {
            type: 3,
            value: parseInt(this.model.enrollmentCount),
          });
        }
      });
    },
    onUseBalanceClick() {
      this.$refs["frm"].validateField("balance", (error) => {
        if (!error) {
          this.$emit("valueChange", {
            type: 1,
            value: convertToFloat(this.model.balance),
          });
        }
      });
    },
    onUseBonusPointClick() {
      this.$refs["frm"].validateField("bonusPoint", (error) => {
        if (!error) {
          this.$emit("valueChange", {
            type: 2,
            value: parseInt(this.model.bonusPoint),
          });
        }
      });
    },
    onCashDecreasedClick() {
      this.$refs["frm"].validateField("cashDecreased", (error) => {
        if (!error) {
          this.$emit("valueChange", {
            type: 4,
            value: convertToFloat(this.model.cashDecreased),
          });
        }
      });
    },
    save(isMoveNext) {
      if (this.checkAllInputs()) {
        this.isChanged = false;
        this.$emit("valueChange", this.model, this.isReduce, isMoveNext);
      }
    },
    saveCashDecreased(isMoveNext) {
      if (this.checkAllInputs2()) {
        if (!!this.model.cashDecreased && !this.model.comment) {
          this.$message.error("分配失败，使用现金减请输入备注");
          return;
        }

        this.$set(this.dataIn.modelData, "__bonusPointChanged", false);
        this.$set(this.dataIn.modelData, "__cashDecreasedChanged", false);
        this.$emit("valueChange2", this.model, this.isReduce, isMoveNext);
      }
    },
    onDisplayEditorClick() {
      this.editorVisible = true;
    },
    onEditorClose() {
      this.editorVisible = false;
    },
    onEditorSave(data) {
      this.englishEnsureScoreData = data;
    },
    onCouponCodeClick() {
      if (!this.couponModel.couponCode) {
        this.$message.error("优惠码不能为空");
        return;
      }
      validateCoupon(this.studentId, this.couponModel.couponCode, 1).then(
        (result) => {
          if (result && result.success) {
            this.$message.success("验证成功");

            this.couponModel.couponDiscountValue = result.data.DiscountValue;
            this.$emit("couponChange", this.couponModel);
          } else {
            this.$message.error(result.message);
          }
        }
      );
    },
    onCouponRevertClick() {
      this.couponModel.couponCode = "";
      this.couponModel.couponDiscountValue = null;
      this.$emit("couponChange", this.couponModel);
    },
    getCouponDiscountDesc(value) {
      return getDiscountDesc(value);
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
    "dataIn.memberModel": function () {
      this.loadFinancialModel();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/useBalanceEditor.vue